// extracted by mini-css-extract-plugin
export default {"ecom-header":"GljGLh","ecomHeader":"GljGLh"};